import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const REPORT_ENDPOINTS = {
  V1: createEndpoints('v1', {
    REPORT: (id: number) => `/report/${id}/`,
    ACCEPT_REJECT_REPORT: (id: number) => `/accept-reject-report/${id}/`,
    GENERATE_PDF_REPORT: (orderID: number) => `/generate-pdf-report/${orderID}/`,
    GENERATE_PDF_GALLERY_REPORT: (orderID: number) => `/generate-pdf-gallery-report/${orderID}/`,
    ORDER_REPORT_FILES: (orderId: number) => `/admin/order-report-files/${orderId}/`,
    DELETE_REPORT_FILE: (orderId: number, fileId: number) => `/admin/order-report-files/${orderId}/${fileId}/`,
  }),
} as const;
